export enum ValidationFormAnswerStateEnum {
  Answered = 0,   //show edittable for admin //scroll bottom show a btn to approve the validation form answer -----> patch validationform answer (state: approved)
  Approved = 1,
  Awaiting = 2
}
